<footer>
  <div class="container">
    ® 2026 Selective Bits<br />
  </div>
</footer>
